// The last line of defence: without it, one throw while rendering unmounts the
// whole tree and leaves the dark page background — a black screen with no way
// out but guessing that a reload might help.

import { Component, type ErrorInfo, type ReactNode } from "react";

interface State {
  error: Error | null;
}

export class ErrorBoundary extends Component<{ children: ReactNode }, State> {
  state: State = { error: null };

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  componentDidCatch(error: Error, info: ErrorInfo): void {
    console.error("Seedbed crashed while rendering.", error, info.componentStack);
  }

  render(): ReactNode {
    if (!this.state.error) return this.props.children;
    return (
      <div className="flex min-h-dvh flex-col items-center justify-center gap-4 p-6 text-center">
        <p className="text-sm text-muted-foreground">Something went wrong loading Seedbed.</p>
        <button
          type="button"
          onClick={() => window.location.reload()}
          className="cursor-pointer rounded-full bg-primary px-5 py-2 text-sm font-semibold text-primary-foreground"
        >
          Reload
        </button>
      </div>
    );
  }
}
